import { LinkList, type ListItemLinkProps } from '@innovationnorway/cl-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export type ReportingLinkListItem = {
  to: string;
  title: string;
  lead?: string;
};

type Props = {
  items: ReportingLinkListItem[];
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>;

const ReportingLinkList = ({ items, ...rest }: Props) => {
  const navigate = useNavigate();

  // ListItemLink renders a plain anchor, so keep navigation inside the SPA router.
  const linkItems: ListItemLinkProps[] = items.map(({ to, title, lead }) => ({
    title,
    lead,
    url: to,
    onClick: (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) {
        return;
      }
      event.preventDefault();
      navigate(to);
    },
  }));

  return <LinkList variant="link" items={linkItems} {...rest} />;
};

export default ReportingLinkList;
